import { render, staticRenderFns } from "./AboutDevelopers.vue?vue&type=template&id=c9e60996&scoped=true&"
import script from "./AboutDevelopers.vue?vue&type=script&lang=js&"
export * from "./AboutDevelopers.vue?vue&type=script&lang=js&"
import style0 from "./AboutDevelopers.vue?vue&type=style&index=0&id=c9e60996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e60996",
  null
  
)

export default component.exports